/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-10 10:41:12
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-07-19 17:11:39
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorNavigation/index.tsx
 */
import { Button } from '@/src/components/Antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
import { dispatch } from 'src/store';
import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RouteBlock from './RouteBlock';
import {
  fetchNavigation,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getHasModified,
  getLoaded,
  getNavigation,
  getNavigations,
  getSalesChannel,
  getSalesChannelName,
  getState,
  getSubmitStamp,
  onAddMenu,
  onAddNavigation,
  onCloneNavigation,
  onCollapseOpen,
  onDeleteMenu,
  onDeleteNavigation,
  onErrorChange,
  onMenuLinkChange,
  onMenuTitleChange,
  onSortMenu,
  onTitleChange,
  onTitleLinkChange,
  resetData,
  submitNavigation,
  validation,
} from './slice';

import ErrorProcessingComponent from '@/src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC/ErrorProcessingComponent';
import styles from './css.less';
import Item from './Item';
import { convertDataFromReduxToServer, navigationValidation } from './tool';

export interface IParams {
  contentUuid: string;
  saleChannelUuid: string;
}

function SalesChannelEditorNavigation(props) {
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    isOnPrimaryLanguage,
  } = props;
  //console.log('hasModified', hasModified);
  const _d = useDispatch();

  const _params: IParams = useParams();
  const navigations = useSelector(getNavigations());
  const { contentUuid } = _params;
  React.useEffect(() => {
    return () => {
      _d(resetData());
    };
  }, []);

  return (
    <React.Fragment>
      <RouteBlock hasModified={hasModified} />
      <PageWrapper
        headerConfig={{
          hasModified: hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName: salesChannelName,
          onDiscard,
          onGoBack,
        }}>
        <div className={styles.container}>
          <div className={styles.title}>{'Navigation Group'}</div>
          <div className={styles.content}>
            {Array.isArray(navigations) &&
              navigations.map((navigation) => {
                return (
                  <ErrorProcessingComponent
                    key={navigation.uuid}
                    getCollapseOpenStatus={getCollapseOpenStatus}
                    onCollapseOpen={onCollapseOpen}
                    headerProps={{
                      dotsFunction: [
                        {
                          onClick: () => {
                            _d(onCloneNavigation({ uuid: navigation.uuid }));
                          },
                          key: 'Duplicate',
                          body: 'Duplicate',
                        },
                        {
                          key: 'Delete',
                          body: 'Delete',
                          isDangerous: true,
                          displayWarningModal: true,
                          onClick: () => void 0,
                          modalOnOk: () => {
                            _d(onDeleteNavigation({ uuid: navigation.uuid }));
                          },
                          modalTitle: 'Delete Navigation',
                          modalContent: 'Are you sure to delete navigation ?',
                        },
                      ],
                      hasDots: true,
                      hideDotsWhenNotPrimary: true,
                    }}
                    id={navigation.uuid}
                    expandOffset={0}
                    getContent={() => getNavigation(navigation.uuid)}
                    title={navigation.title}
                    getErrorDisplay={getCollapseValidationMsgDisplay}
                    onErrorChange={onErrorChange}
                    validation={(x, _p) => {
                      return navigationValidation(x);
                    }}
                    getSubmitStamp={getSubmitStamp}
                    renderComponent={(errorProcessingProps: any) => (
                      <Item
                        {...navigation}
                        errorProcessingProps={errorProcessingProps}
                        isOnPrimaryLanguage={isOnPrimaryLanguage}
                        contentUuid={contentUuid}
                        onTitleChange={(uuid, value) => {
                          //console.log(uuid, value);
                          _d(onTitleChange({ uuid, value }));
                        }}
                        onTitleLinkChange={(uuid, value) => {
                          _d(onTitleLinkChange({ uuid, value }));
                        }}
                        onMenuTitleChange={(index, uuid, value) => {
                          _d(
                            onMenuTitleChange({
                              navigationUuid: uuid,
                              index,
                              value,
                            }),
                          );
                        }}
                        onMenuLinkChange={(index, uuid, value) => {
                          _d(
                            onMenuLinkChange({
                              navigationUuid: uuid,
                              index,
                              value,
                            }),
                          );
                        }}
                        onSort={(uuid, data) => {
                          const { newIndex, oldIndex } = data?.data || {};
                          _d(onSortMenu({ uuid, newIndex, oldIndex }));
                        }}
                        onAdd={(uuid) => {
                          _d(onAddMenu({ uuid }));
                        }}
                        onDelete={(uuid, index) => {
                          _d(onDeleteMenu({ uuid, index }));
                        }}
                      />
                    )}
                  />
                );
              })}
          </div>
          <div className={styles.add}>
            <Button type={'primary'} onClick={() => _d(onAddNavigation({}))}>
              {'Add Group'}
            </Button>
          </div>
        </div>
      </PageWrapper>
    </React.Fragment>
  );
}
// (uuid, value) => _d(onTitleChange({ uuid, value }))

export default BasicPageHOC(SalesChannelEditorNavigation, {
  getState,
  convertDataFromReduxToServer,
  submit: submitNavigation,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  getLoaded,
  validation,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchNavigation({
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
